import { useEffect, useState, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

import "../recognition-result/style.scss";
import { fetchPrompt, patchPrompt } from "../../../api/admin/prompt/endpoints-referrers";
import { LoaderView } from "../../../components/loader/loader.comp";
import HeaderLayout from "../../../components/layout/header-layout.comp";

const PromptTuningView = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [currentPrompt, setCurrentPrompt] = useState<string>();
    const [promptText, setPromptText] = useState<string>("");

    useEffect(() => {
        setIsLoading(true);

        fetchPrompt()
            .then(response => {
                const prompt = response.data;
                setCurrentPrompt(prompt);
                setPromptText(prompt ?? "");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleSaveClick = () => {
        setIsLoading(true);
        patchPrompt(promptText)
            .then(() => {
                handleBackClick();
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleTextChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setPromptText(event.target.value);
    };

    return (
        <HeaderLayout
            subheaderHeight={46}
            subheader={
                <div className="rr-header">
                    <div className="rr-header-title">
                        <span className="rr-header-title__text">Prompt Tuning</span>
                    </div>
                </div>
            }
            footerHeight={60}
            footer={
                <div style={{ height: 60 }} className="rr-footer">
                    <div className="rr-footer-left">
                        <Button
                            className="primary-button"
                            variant="outlined"
                            disabled={!promptText || currentPrompt === promptText}
                            onClick={handleSaveClick}
                        >
                            Save
                        </Button>
                    </div>
                </div>
            }
        >
            <div className="rr-view">
                <div className="rr-content">
                    <textarea
                        className="rr-content__textarea"
                        onChange={handleTextChange}
                        value={promptText}
                    />
                </div>
                <LoaderView show={isLoading} />
            </div>
        </HeaderLayout>
    );
};

export default PromptTuningView;
